"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewLinkBannerMobile = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./style.css"));
var _uiKit = require("@cian/ui-kit");
var _NewBannerText = require("../NewBannerText");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NewLinkBannerMobile = _ref => {
  let {
    onClick,
    url
  } = _ref;
  const device = (0, _uiKit.useDeviceType)();
  const buttonSize = React.useMemo(() => device === 'phone' ? 'XS' : 'M', [device]);
  return /*#__PURE__*/React.createElement("a", {
    className: style['banner'],
    href: url,
    target: "_blank",
    onClick: onClick,
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info-text']
  }, /*#__PURE__*/React.createElement(_NewBannerText.NewBannerText, {
    isCallback: false
  })), /*#__PURE__*/React.createElement("div", {
    className: style['button']
  }, /*#__PURE__*/React.createElement(_uiKit.LinkButton, {
    theme: "fill_white_primary",
    size: buttonSize,
    color: "current_color"
  }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0443"))), /*#__PURE__*/React.createElement("div", {
    className: style['image']
  }));
};
exports.NewLinkBannerMobile = NewLinkBannerMobile;